import { render, staticRenderFns } from "./AcademyLogin.vue?vue&type=template&id=e4705d10&scoped=true&lang=pug&"
import script from "./AcademyLogin.vue?vue&type=script&lang=ts&"
export * from "./AcademyLogin.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyLogin.vue?vue&type=style&index=0&id=e4705d10&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4705d10",
  null
  
)

export default component.exports